module.exports = __webpack_public_path__ + "img/li.a218ada7.svg";